// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/etl/v1/etl.proto (package mono.etl.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Struct, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.etl.v1.ProcessDocumentRequest
 */ export class ProcessDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProcessDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProcessDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProcessDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProcessDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bytes file_data = 1;
   */ _define_property(this, "fileData", new Uint8Array(0)), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string content_type = 3;
   */ _define_property(this, "contentType", ""), /**
   * @generated from field: string tenant_id = 4;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 5;
   */ _define_property(this, "projectId", ""), /**
   * Processing options. Accepted keys:
   *   "output_format"       — "markdown" (default), "json", or "html"
   *   "use_deep_processing" — "true" to force Marker/Datalab extraction
   *
   * @generated from field: google.protobuf.Struct options = 6;
   */ _define_property(this, "options", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProcessDocumentRequest, "runtime", proto3);
_define_property(ProcessDocumentRequest, "typeName", "mono.etl.v1.ProcessDocumentRequest");
_define_property(ProcessDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "file_data",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "options",
            kind: "message",
            T: Struct
        }
    ]));
/**
 * @generated from message mono.etl.v1.ProcessDocumentResponse
 */ export class ProcessDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProcessDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProcessDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProcessDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProcessDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string job_id = 1;
   */ _define_property(this, "jobId", ""), /**
   * @generated from field: string status = 2;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string message = 3;
   */ _define_property(this, "message", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProcessDocumentResponse, "runtime", proto3);
_define_property(ProcessDocumentResponse, "typeName", "mono.etl.v1.ProcessDocumentResponse");
_define_property(ProcessDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.etl.v1.SubmitJobRequest
 */ export class SubmitJobRequest extends Message {
    static fromBinary(bytes, options) {
        return new SubmitJobRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubmitJobRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubmitJobRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubmitJobRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string type = 1;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: google.protobuf.Struct parameters = 4;
   */ _define_property(this, "parameters", void 0), /**
   * Native binary file data — avoids base64 encoding overhead (33% size increase).
   * When set, the handler uses this instead of base64-decoded parameters["file_bytes"].
   *
   * @generated from field: bytes file_data = 5;
   */ _define_property(this, "fileData", new Uint8Array(0));
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubmitJobRequest, "runtime", proto3);
_define_property(SubmitJobRequest, "typeName", "mono.etl.v1.SubmitJobRequest");
_define_property(SubmitJobRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "parameters",
            kind: "message",
            T: Struct
        },
        {
            no: 5,
            name: "file_data",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        }
    ]));
/**
 * @generated from message mono.etl.v1.SubmitJobResponse
 */ export class SubmitJobResponse extends Message {
    static fromBinary(bytes, options) {
        return new SubmitJobResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubmitJobResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubmitJobResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubmitJobResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.etl.v1.Job job = 1;
   */ _define_property(this, "job", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubmitJobResponse, "runtime", proto3);
_define_property(SubmitJobResponse, "typeName", "mono.etl.v1.SubmitJobResponse");
_define_property(SubmitJobResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job",
            kind: "message",
            T: Job
        }
    ]));
/**
 * @generated from message mono.etl.v1.ListJobsRequest
 */ export class ListJobsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListJobsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListJobsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListJobsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListJobsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string status = 2;
   */ _define_property(this, "status", ""), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: int32 offset = 4;
   */ _define_property(this, "offset", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListJobsRequest, "runtime", proto3);
_define_property(ListJobsRequest, "typeName", "mono.etl.v1.ListJobsRequest");
_define_property(ListJobsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.etl.v1.ListJobsResponse
 */ export class ListJobsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListJobsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListJobsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListJobsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListJobsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.etl.v1.Job jobs = 1;
   */ _define_property(this, "jobs", []), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListJobsResponse, "runtime", proto3);
_define_property(ListJobsResponse, "typeName", "mono.etl.v1.ListJobsResponse");
_define_property(ListJobsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "jobs",
            kind: "message",
            T: Job,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.etl.v1.GetJobRequest
 */ export class GetJobRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetJobRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetJobRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetJobRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetJobRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetJobRequest, "runtime", proto3);
_define_property(GetJobRequest, "typeName", "mono.etl.v1.GetJobRequest");
_define_property(GetJobRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.etl.v1.GetJobResponse
 */ export class GetJobResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetJobResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetJobResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetJobResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetJobResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.etl.v1.Job job = 1;
   */ _define_property(this, "job", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetJobResponse, "runtime", proto3);
_define_property(GetJobResponse, "typeName", "mono.etl.v1.GetJobResponse");
_define_property(GetJobResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job",
            kind: "message",
            T: Job
        }
    ]));
/**
 * @generated from message mono.etl.v1.CancelJobRequest
 */ export class CancelJobRequest extends Message {
    static fromBinary(bytes, options) {
        return new CancelJobRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CancelJobRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CancelJobRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CancelJobRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CancelJobRequest, "runtime", proto3);
_define_property(CancelJobRequest, "typeName", "mono.etl.v1.CancelJobRequest");
_define_property(CancelJobRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.etl.v1.CancelJobResponse
 */ export class CancelJobResponse extends Message {
    static fromBinary(bytes, options) {
        return new CancelJobResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CancelJobResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CancelJobResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CancelJobResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string message = 1;
   */ _define_property(this, "message", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CancelJobResponse, "runtime", proto3);
_define_property(CancelJobResponse, "typeName", "mono.etl.v1.CancelJobResponse");
_define_property(CancelJobResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.etl.v1.GetJobStatusRequest
 */ export class GetJobStatusRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetJobStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetJobStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetJobStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetJobStatusRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetJobStatusRequest, "runtime", proto3);
_define_property(GetJobStatusRequest, "typeName", "mono.etl.v1.GetJobStatusRequest");
_define_property(GetJobStatusRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.etl.v1.GetJobStatusResponse
 */ export class GetJobStatusResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetJobStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetJobStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetJobStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetJobStatusResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string status = 2;
   */ _define_property(this, "status", ""), /**
   * @generated from field: float progress = 3;
   */ _define_property(this, "progress", 0), /**
   * @generated from field: string message = 4;
   */ _define_property(this, "message", ""), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetJobStatusResponse, "runtime", proto3);
_define_property(GetJobStatusResponse, "typeName", "mono.etl.v1.GetJobStatusResponse");
_define_property(GetJobStatusResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "progress",
            kind: "scalar",
            T: 2 /* ScalarType.FLOAT */ 
        },
        {
            no: 4,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * Job represents an ETL pipeline job.
 *
 * @generated from message mono.etl.v1.Job
 */ export class Job extends Message {
    static fromBinary(bytes, options) {
        return new Job().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Job().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Job().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Job, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string type = 2;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string status = 3;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string tenant_id = 4;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 5;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: float progress = 6;
   */ _define_property(this, "progress", 0), /**
   * @generated from field: string message = 7;
   */ _define_property(this, "message", ""), /**
   * @generated from field: google.protobuf.Struct parameters = 8;
   */ _define_property(this, "parameters", void 0), /**
   * @generated from field: google.protobuf.Struct result = 9;
   */ _define_property(this, "result", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp completed_at = 12;
   */ _define_property(this, "completedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Job, "runtime", proto3);
_define_property(Job, "typeName", "mono.etl.v1.Job");
_define_property(Job, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "progress",
            kind: "scalar",
            T: 2 /* ScalarType.FLOAT */ 
        },
        {
            no: 7,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "parameters",
            kind: "message",
            T: Struct
        },
        {
            no: 9,
            name: "result",
            kind: "message",
            T: Struct
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "completed_at",
            kind: "message",
            T: Timestamp
        }
    ]));
